/* DP Cart – carrinho lateral próprio (substitui o Kaching Cart) */
(function () {
  'use strict';
  var drawer = document.querySelector('[data-dp-drawer]');
  if (!drawer) return;
  var panel = drawer.querySelector('[data-dp-panel]');
  var root = function () { return panel.querySelector('#dp-cart-root'); };
  if (!root() || root().dataset.enabled !== 'true') return;

  document.documentElement.classList.add('dp-active');
  var SECTION = 'dp-cart';
  var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var busy = false;
  var nativeFetch = window.fetch.bind(window);

  function req(url, body) {
    return nativeFetch(rootUrl + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-DP-Cart': '1' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  function render(html) {
    if (!html) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('#dp-cart-root');
    var current = root();
    var oldLevel = current ? parseInt(current.dataset.tierLevel || '0', 10) : 0;
    if (fresh && current) current.replaceWith(fresh);
    if (fresh && fresh.dataset.confetti === 'true' && parseInt(fresh.dataset.tierLevel || '0', 10) > oldLevel) {
      setTimeout(confetti, drawer.classList.contains('is-open') ? 50 : 400);
    }
    tickTimer();
    syncHeaderCount();
  }

  function refresh() {
    return nativeFetch(rootUrl + '?sections=' + SECTION, { headers: { 'X-DP-Cart': '1' } })
      .then(function (r) { return r.json(); })
      .then(function (j) { render(j[SECTION]); });
  }

  function syncHeaderCount() {
    var r = root();
    if (!r) return;
    var count = r.dataset.itemCount || '0';
    document.querySelectorAll('cart-count, [data-cart-count]').forEach(function (el) {
      if (el.closest('[data-dp-drawer]')) return;
      el.setAttribute('data-cart-count', count);
      var n = parseInt(count, 10);
      var limit = parseInt(el.getAttribute('data-limit') || '0', 10);
      el.textContent = limit && n >= limit ? (limit - 1) + '+' : count;
    });
  }

  function open() {
    startTimer();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('dp-lock');
    refresh();
  }

  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('dp-lock');
  }

  function closeThemeDrawer() {
    var td = document.querySelector('cart-drawer#cart-drawer');
    if (td && typeof td.closeCartDrawer === 'function') {
      try { td.closeCartDrawer(); } catch (e) {}
    }
  }

  // Atualiza o carrinho com a resposta da secção, e avisa o tema (contadores)
  function mutate(promise) {
    if (busy) return;
    busy = true;
    var r = root();
    if (r) r.classList.add('is-loading');
    return promise
      .then(function (res) {
        if (res && res.sections && res.sections[SECTION]) render(res.sections[SECTION]);
        else return refresh();
      })
      .catch(function (err) {
        if (err && err.description) alert(err.description);
        return refresh();
      })
      .then(function () {
        busy = false;
        var r2 = root();
        if (r2) r2.classList.remove('is-loading');
        document.dispatchEvent(new CustomEvent('dp:cart:updated'));
      });
  }

  function changeQty(key, qty) {
    return mutate(req('cart/change.js', { id: key, quantity: qty, sections: SECTION }));
  }

  function changeVariant(itemEl) {
    var script = itemEl.querySelector('[data-dp-variants]');
    if (!script) return;
    var variants = JSON.parse(script.textContent);
    var chosen = Array.prototype.map.call(itemEl.querySelectorAll('[data-dp-option]'), function (s) { return s.value; });
    var match = variants.find(function (v) { return v.o.every(function (o, i) { return o === chosen[i]; }); });
    if (!match) { alert('Tato kombinace není k dispozici.'); return refresh(); }
    if (!match.a) { alert('Tato varianta je vyprodaná.'); return refresh(); }
    var oldId = (itemEl.dataset.key || '').split(':')[0];
    var qty = parseInt(itemEl.dataset.qty, 10) || 1;
    if (String(match.id) === String(oldId)) return;
    var updates = {};
    updates[oldId] = 0;
    updates[match.id] = qty;
    return mutate(req('cart/update.js', { updates: updates, sections: SECTION }));
  }

  function toggleProtection(btn) {
    var r = root();
    var vid = parseInt(r.dataset.protectionVariant, 10);
    if (!vid) return;
    var on = btn.classList.contains('is-on');
    btn.classList.toggle('is-on', !on);
    if (on) return mutate(req('cart/change.js', { id: String(vid), quantity: 0, sections: SECTION }));
    return mutate(req('cart/add.js', { items: [{ id: vid, quantity: 1 }], sections: SECTION }));
  }

  // ---------- contador de reserva ----------
  var TIMER_KEY = 'dpCartTimerEnd';
  function startTimer() {
    var mins = parseFloat((root() && root().dataset.timerMinutes) || '10') || 10;
    var end = 0;
    try { end = parseInt(sessionStorage.getItem(TIMER_KEY) || '0', 10); } catch (e) {}
    if (!end || end <= Date.now()) {
      end = Date.now() + mins * 60000;
      try { sessionStorage.setItem(TIMER_KEY, String(end)); } catch (e) {}
    }
    drawer._dpTimerEnd = end;
    tickTimer();
  }
  function tickTimer() {
    var el = panel.querySelector('[data-dp-timer]');
    if (!el) return;
    if (!drawer._dpTimerEnd) startTimer();
    var left = Math.max(0, Math.round((drawer._dpTimerEnd - Date.now()) / 1000));
    if (left === 0) { try { sessionStorage.removeItem(TIMER_KEY); } catch (e) {} drawer._dpTimerEnd = 0; startTimer(); return; }
    var m = Math.floor(left / 60), s = left % 60;
    el.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
  }
  setInterval(tickTimer, 1000);
  startTimer();

  // ---------- eventos dentro do carrinho ----------
  drawer.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-dp-close]')) { e.preventDefault(); return close(); }
    var item = t.closest('.dp-item');
    var qtyBtn = t.closest('[data-dp-qty]');
    if (qtyBtn && item) {
      var q = (parseInt(item.dataset.qty, 10) || 0) + parseInt(qtyBtn.dataset.dpQty, 10);
      return changeQty(item.dataset.key, Math.max(0, q));
    }
    if (t.closest('[data-dp-remove]') && item) return changeQty(item.dataset.key, 0);
    var sw = t.closest('[data-dp-protection]');
    if (sw) return toggleProtection(sw);
  });
  drawer.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-dp-option]');
    if (sel) changeVariant(sel.closest('.dp-item'));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  // ---------- substituir a gaveta do tema ----------
  // ícone do carrinho no cabeçalho
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-cart-toggle], a[href="/cart"], a[href="' + rootUrl + 'cart"]');
    if (!link || link.closest('[data-dp-drawer]')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    drawer.classList.contains('is-open') ? close() : open();
  }, true);

  // o tema pede para abrir/alternar a sua gaveta -> abrimos a nossa
  ['theme:cart:toggle', 'theme:cart-drawer:show'].forEach(function (name) {
    window.addEventListener(name, function (e) {
      e.stopImmediatePropagation();
      open();
    }, true);
  });
  document.addEventListener('theme:cart-drawer:open', function () {
    setTimeout(closeThemeDrawer, 0);
    open();
  });

  // qualquer outro "adicionar ao carrinho" (apps, upsells) também abre o carrinho
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var headers = (init && init.headers) || {};
    var own = headers['X-DP-Cart'] || (headers.get && headers.get('X-DP-Cart'));
    var p = nativeFetch(input, init);
    if (!own && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
      p.then(function (r) { if (r.ok) setTimeout(open, 150); });
    } else if (!own && /\/cart\/(change|update|clear)(\.js)?(\?|$)/.test(url) && drawer.classList.contains('is-open')) {
      p.then(function () { setTimeout(refresh, 150); });
    }
    return p;
  };

  // ---------- confettis ao desbloquear um desconto ----------
  function confetti() {
    var canvas = document.createElement('canvas');
    canvas.className = 'dp-confetti';
    panel.appendChild(canvas);
    var dpr = window.devicePixelRatio || 1;
    var W = panel.clientWidth, H = panel.clientHeight;
    canvas.width = W * dpr; canvas.height = H * dpr;
    canvas.style.width = W + 'px'; canvas.style.height = H + 'px';
    var ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);
    var colors = ['#1fa22e', '#ffd23f', '#ff5e5b', '#3fa7ff', '#a259ff', '#ff9f1c'];
    var parts = [];
    for (var i = 0; i < 160; i++) {
      var fromLeft = i % 2 === 0;
      parts.push({
        x: fromLeft ? 0 : W, y: H * 0.35,
        vx: (fromLeft ? 1 : -1) * (3 + Math.random() * 7), vy: -(4 + Math.random() * 9),
        w: 5 + Math.random() * 6, h: 3 + Math.random() * 5,
        r: Math.random() * Math.PI, vr: (Math.random() - .5) * .3,
        c: colors[i % colors.length]
      });
    }
    var start = performance.now();
    (function frame(now) {
      var t = now - start;
      ctx.clearRect(0, 0, W, H);
      parts.forEach(function (p) {
        p.vy += 0.25; p.vx *= 0.985; p.x += p.vx; p.y += p.vy; p.r += p.vr;
        ctx.save();
        ctx.globalAlpha = Math.max(0, 1 - t / 2600);
        ctx.translate(p.x, p.y); ctx.rotate(p.r);
        ctx.fillStyle = p.c; ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore();
      });
      if (t < 2600) requestAnimationFrame(frame); else canvas.remove();
    })(start);
  }

  window.DPCart = { open: open, close: close, refresh: refresh, confetti: confetti };
})();
